import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import _ from 'lodash';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

/* FIXME: [DEV-449] Shouldn't care about ticketFacts or JobApprovalInbox.
 * FIXME: Need to be refetched elsewhere. */
import { Query as TicketFactsQuery } from '../../../tickets/components/TicketFacts';
import { GetVerifiableJobs } from '../../../ticketApprovals/graphql/verifiableJobsQuery';
import { GetTicketsByJobIdQuery } from '../../../ticketViewer/graphql/jobTicketsApi';
import { TicketViewerQuery } from '../../../tickets/components/TicketSubmissionItemViewer';
import { GetJobByTicketQuery } from '../../../tickets/components/JobFacts';
import { GetTicketCalculatedFieldsQuery } from '../../../tickets/components/TicketCalculatedFields';

import { LeaseInputLeaseFragment } from '../../../fields/LeaseInput';
import { OperatorInputOperatorFragment } from '../../../fields/OperatorInput';
import { GetJobReviewInboxQuery } from '../../../fieldAdminReview/graphql/initialJobStateQuery';

const TicketEntryFragment = gql`
  fragment TicketEntryFragment on Ticket {
    id
    immutable_reason
    mutable
    supplemental_info
    state
    date {
      display
    }
    department {
      id
      name
      has_hourly_billing
    }
    district {
      id
      name
    }
    equipment {
      edges {
        node {
          id
          equipment_number
        }
      }
    }
    ticket_number {
      id
      number
      documentId: document_id
    }
    job {
      id
      job_number
      lease {
        id
        lookup {
          ...LeaseInputLease
        }
        operator {
          id
          lookup {
            ...OperatorInputOperatorLookup
          }
        }
      }
    }
    billing_hours
    billing_revenue
    recommended_feedback
    operator: operator_lookup {
      ...OperatorInputOperatorLookup
    }
    lease: lease_lookup {
      ...LeaseInputLease
    }
    well: well_lookup {
      id
      user_id
      name
    }
  }
  ${LeaseInputLeaseFragment}
  ${OperatorInputOperatorFragment}
`;
const GetTicketQuery = gql`
  query GetTicket($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      ...TicketEntryFragment
    }
  }
  ${TicketEntryFragment}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const [results] = querySelector(data, '$.ticket', []);
  const equipment = querySelector(data, '$.ticket.equipment.edges[*].node', []);
  const [well] = querySelector(data, '$.ticket.well', []);
  const [lease] = querySelector(data, '$.ticket.lease', []);
  const [operator] = querySelector(data, '$.ticket.operator', []);

  const ticket = {
    ...results,
    well,
    lease,
    operator,
    equipment,
  };

  ticket.date = results.date.display;

  return {
    ticket,
  };
});

export const querySingleTicketData = graphql(GetTicketQuery);

export const QuerySingleTicketGQL = compose(
  querySingleTicketData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);

/* Update Ticket Mutation */

export const UpdateTicketMutation = gql`
  mutation UpdateTicket($input: TicketFormUpdateInput!) {
    ticket_form_update(input: $input) {
       ...TicketEntryFragment
       worked_hours_equals_billing
    }
  }
  ${TicketEntryFragment}
`;

export const updateTicketMutationGQL = async (client, ticket, districtId, departmentId, paramJobId) => {
  const ticketId = ticket.id;

  const variables = {
    input: {
      ticket: {
        ..._.omit(ticket, ['__typename', 'job.lease', 'lease.lease']),
      },
    },
  };

  const currentDistrictId = (districtId) || null;
  const currentDepartmentId = (departmentId) || null;
  const jobId = (paramJobId) || null;

  const refetchQueries = [
    {
      query: TicketFactsQuery,
      variables: {
        ticketId,
      },
    },
    {
      query: TicketViewerQuery,
      variables: {
        ticketId,
      },
    },
    {
      query: GetVerifiableJobs,
      variables: {
        currentDistrictId,
        currentDepartmentId,
      },
    },
    {
      query: GetTicketsByJobIdQuery,
      variables: {
        jobId,
      },
    },
    {
      query: GetJobByTicketQuery,
      variables: {
        ticketId,
      },
    },
    {
      query: GetTicketCalculatedFieldsQuery,
      variables: {
        ticketId,
      },
    },
    {
      query: GetJobReviewInboxQuery,
      variables: {
        currentDistrictId,
        currentDepartmentId,
      },
    },
  ];

  const options = {
    mutation: UpdateTicketMutation,
    variables,
    refetchQueries,
  };
  return client.mutate(options);
};
